<!--中间地图-->
<template>
	<div class="middleMapBody">
		<!--头部-->
		<div class="middleMapTitle">
			<div class="titleDiv" :style="getBackgroudImageStyle('/huanbao/billboard/xiaoKuan.png')">
				<span>297<span>个</span></span>
				<span>企业数量</span>
			</div>
			<div class="titleDiv" :style="getBackgroudImageStyle('/huanbao/billboard/xiaoKuan.png')">
				<span>885<span>个</span></span>
				<span>治污监测点数量</span>
			</div>
			<div class="titleDiv" :style="getBackgroudImageStyle('/huanbao/billboard/xiaoKuan.png')">
				<span>878<span>个</span></span>
				<span>产污监测点数量</span>
			</div>
			<div class="titleDiv" :style="getBackgroudImageStyle('/huanbao/billboard/xiaoKuan.png')">
				<span>1764<span>个</span></span>
				<span>监测点数量</span>
			</div>
		</div>
		<!--echart地图部分-->
		<div class="echartMap">
			<div id="zkMap" ref="myEchart"></div>
		</div>
	</div>
</template>

<script>
	import echarts from "echarts";
	import '../../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
	export default {
		components: {},
		props: {},
		data() {
			return {
			}
		},
		created() {},
		mounted() {
			this.chinaConfigure()
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
		},
		watch: {},
		methods: {
			chinaConfigure() {
				let myChart = echarts.init(this.$refs.myEchart);
				window.onresize = myChart.resize;
				myChart.setOption({ // 进行相关配置
					backgroundColor: "rgba(0,0,0,0)",
					tooltip: {
						show: false
					}, // 鼠标移到图里面的浮动提示框
					dataRange: {
						show: false,
						min: 1.2,
						max: 1000,
						text: ['High', 'Low'],
						realtime: true,
						calculable: true,
						color: ['#2ed1ff', '#b0eeff']
					},
					geo: { // 这个是重点配置区
						map: 'china', // 表示中国地图
						roam: false, //禁用移动
						label: {
							normal: {
								show: false, // 是否显示对应地名
							}
						},
						scaleLimit: {
							max: 1.2,
							min: 1.2,
						},
						zoom: 1.2,
						itemStyle: {
							borderColor: '#3366cc',
							borderWidth: 1,
							borderType: 'solid',
							areaColor: '#0c0d49',
						},
						emphasis: {
							itemStyle: {
								areaColor: null,
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								shadowBlur: 20,
								borderWidth: 0,
								shadowColor: 'rgba(51, 0, 0, 10)'
							},
							label: {
								show: false, // 是否显示对应地名
							},
						},
						regions: [{
							name: "南海诸岛",
							value: 0,
							itemStyle: {
								normal: {
									opacity: 0,
									label: {
										show: false
									}
								}
							}
						}]
					},
					series: [{
							type: 'scatter',
							coordinateSystem: 'geo' // 对应上方配置
						},
						{
							name: '启动次数', // 浮动框的标题
							type: 'map',
							geoIndex: 0,
							itemStyle: {
								opacity: 0,
							},
							data: [{
									name: "广东",
									value: 10
								},
								{
									name: "广西",
									value: 10
								},
								{
									name: "河北",
									value: 80
								},
								{
									name: "浙江",
									value: 10
								}
							],
							markPoint: {
								symbol: 'circle',
								symbolSize: 10,
								itemStyle: {
									color: 'red',
								},
								animation: true,
								animationThreshold: 5000,
								data: [{
									name: '某个坐标',
									coord: [116.326368, 39.968263]
								}, {
									name: '某个坐标',
									coord: [116.738007, 35.627363]
								}, {
									name: '某个坐标',
									coord: [115.928526, 27.773429]
								}, {
									name: '某个坐标',
									coord: [115.928526, 27.773429]
								}]
							},

						}
					]
				})
			}
		}
	}
</script>

<style scoped>
	.middleMapBody {
		width: 46%;
		height: 95%;
	}
	
	.middleMapTitle {
		width: 100%;
		height: 15%;
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: relative;
		z-index: 10;
		top: 0;
	}
	
	.titleDiv {
		width: 20%;
		height: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	
	.titleDiv span:nth-child(1) {
		color: white;
		font-size: .18rem;
		line-height: .25rem;
	}
	
	.titleDiv span:nth-child(1) span {
		font-size: .12rem;
	}
	
	.titleDiv span:nth-child(2) {
		color: #2972cd;
	}
	
	.echartMap {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 9;
		top: -15%;
	}
	
	#zkMap {
		width: 100%;
		height: 100%;
	}
</style>